function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "ic-share-connect_svg__a",
  width: "125%",
  height: "125%",
  x: "-12.5%",
  y: "-10.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
})), React.createElement("circle", {
  id: "ic-share-connect_svg__b",
  cx: 56,
  cy: 56,
  r: 56
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0-2h130v130H0z"
}), React.createElement("g", {
  transform: "translate(9 7)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#ic-share-connect_svg__a)",
  xlinkHref: "#ic-share-connect_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2,
  xlinkHref: "#ic-share-connect_svg__b"
})), React.createElement("path", {
  d: "M29 27h72v72H29z"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M68.35 62.5a3.85 3.85 0 10-7.7 0 3.85 3.85 0 007.7 0M64.525 35a3.3 3.3 0 10-.003 6.6h.003a3.3 3.3 0 00.003-6.6h-.003m-.101 48.4a3.3 3.3 0 00-.01 6.6h.01a3.3 3.3 0 00.01-6.6h-.01m17.126-6.476a2.75 2.75 0 101.937 4.701 2.749 2.749 0 00-1.937-4.7m-34.207-.108a2.749 2.749 0 101.94 4.7 2.751 2.751 0 00.01-3.89v.001a2.74 2.74 0 00-1.95-.81M88.7 59.25c-1.823 0-3.3 1.461-3.3 3.263v.062c-.008 1.801 1.464 3.268 3.287 3.275h.013c1.816 0 3.292-1.452 3.3-3.249v-.088c0-1.802-1.477-3.263-3.3-3.263m-48.4-.1a3.3 3.3 0 00-.007 6.6h.007a3.3 3.3 0 00.006-6.6H40.3m7.114-16.54a2.751 2.751 0 000 5.5 2.75 2.75 0 000-5.5"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M71.926 68.275l4.154 5.077"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M73.25 72.838l2.624.263.262-2.625 1.003 1.225-.263 2.625-2.623-.263z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2,
  d: "M72.646 63.05h7.124"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M76.484 65.847l2.798-2.797-2.8-2.797h2.376l2.798 2.797-2.797 2.797z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M70.827 56.725l5.159-5.161"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M75.756 54.432v-2.638l-2.638.001 1.12-1.12h2.636l.001 2.637z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2,
  d: "M64.502 54.905L64.5 47.78"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M67.298 51.067l-2.797-2.798-2.797 2.798v-2.375l2.796-2.797 2.798 2.796z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2,
  d: "M64.5 70.095l.001 7.124"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M61.703 73.933l2.798 2.798 2.797-2.798v2.375l-2.796 2.797-2.799-2.796z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M58.174 68.275l-5.161 5.162"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M53.243 70.568v2.638h2.637l-1.119 1.12h-2.638v-2.638z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2,
  d: "M56.354 63.05H49.23"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M52.517 60.253l-2.8 2.796 2.799 2.798H50.14l-2.797-2.798 2.798-2.796z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M58.173 56.725l-5.159-5.161"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M55.882 51.795h-2.638v2.637l-1.12-1.12.002-2.638 2.636.002z"
}), React.createElement("g", {
  transform: "translate(14.49 8.098)"
}, React.createElement("circle", {
  cx: 13.176,
  cy: 13.176,
  r: 12.176,
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2
}), React.createElement("path", {
  fill: "#12123B",
  d: "M16.922 14.854c.549 0 .823.23.823.69 0 .458-.274.688-.823.688h-1.075v1.663c0 .28-.078.496-.235.647-.157.151-.364.227-.622.227a.835.835 0 01-.605-.227c-.156-.151-.235-.367-.235-.647v-1.663H9.43c-.247 0-.437-.067-.572-.202a.705.705 0 01-.201-.52c0-.224.072-.443.218-.656l5.36-7.71a.868.868 0 01.755-.387.87.87 0 01.605.227c.168.15.252.366.252.646v7.224h1.075zm-6.4 0h3.628V9.613l-3.629 5.241z"
})));

var SvgIcShareConnect = function SvgIcShareConnect(props) {
  return React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcShareConnect as ReactComponent };